<template>
  <div class="row">
    <div class="col">
      <!-- <card>
        <div>AEGEAN S.A.</div>
        <ul>
          <li><a target="_blank" href="https://cdn.theecoverse.net/reports/companies/aegean/aegean_concise_report.pdf">ESG concise report</a></li>
        </ul>
      </card> -->
    </div>
  </div>
</template>
<script>
  export default {
    components: {
      
    },
    data() {
      return {
        
      }
    }
  }
</script>
<style>
</style>
